import React from 'react';

import { useHistory } from 'react-router';
import { ButtonLounge } from 'app/shared/components/common/button/button-louge';
import AvatarWithBadge from 'app/shared/components/mobile/avatar-with-badge/avatar-with-badge';
import { useSelector } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { Card } from '@material-ui/core';
import { getContractEngineSelector } from 'app/modules/cms/service/store/selectors';
import { getResindSelector } from 'app/modules/cms/service/store/selectors';
import './style.scss';

const RescindTelepohone = () => {
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);
  const resindSelector: any = useSelector(getResindSelector);
  const history = useHistory();
  return (
    <>
      <div className="mobile-contract-rescind-confirmation">
        <div className="avatar-style">
          <AvatarWithBadge
            hideButton
            avatar={avatar}
            getPreviousStep={() => {
              history.push({
                pathname: '/contract-engine',
              });
            }}
            title={[resindSelector?.avatar_text_phone_mode]}
          />
        </div>
        <div className="confirmation-card d-flex justify-content-center text-center align-items-center">
          <Card className="w-100 p-3">
            <img src={resindSelector?.phone_contact?.url} className="image-stop-style" />
            <p className="text-gray">{resindSelector?.phone_contact_text}</p>
            <p
              className="home-link-style"
              onClick={() => {
                history.push({
                  pathname: '/contract-engine',
                });
              }}
            >
              <hr />
              <ButtonLounge
                title={resindSelector?.back_button}
                style={'Mobile1 align-self-center mt-1'}
                action={() => {
                  history.push({
                    pathname: '/contract-engine',
                  });
                }}
              />
            </p>
          </Card>
        </div>
      </div>
    </>
  );
};

export default RescindTelepohone;
